<template>
  <!-- SIDE PANEL -->
  <div class="vx-col panel side-panel bg-grey lg:h-full lg:w-1/3 sm:w-1/1 p-0"
        :class="{ 'hide': !sidePanelActive }"
  >
    <div class="flex w-full bg-white p-8 justify-between">
      <span class="my-auto text-xl">
        {{ $t("general.class-content") }}
      </span>
      <vs-button color="grey" icon-pack="feather" icon="icon-x"
                 @click="$emit('toggleSidePanel',false)" radius >
      </vs-button>
    </div>
    <vs-divider class="w-full m-0 p-0 bg-grey"/>

    <!-- SIDE PANEL CONTENT -->
    <SidePanelContent :courseOutlineUnits="courseOutlineUnits"
                      :courseOutlineUnitLoading="courseOutlineUnitLoading"
                      :handlerTopicClick="handlerTopicClick"
                      :handlerStartTestClick="handlerStartTestClick"
                      :triggerLoading="triggerLoading">
    </SidePanelContent>
  </div>
</template>

<script>
import SidePanelContent from "./content.vue";

export default {
  props:[
    'sidePanelActive',
    'courseOutlineUnits',
    'courseOutlineUnitLoading',
    'handlerTopicClick',
    'handlerStartTestClick',
    'triggerLoading',
  ],
  components: {
    SidePanelContent
  },
}
</script>

<style>
.side-panel {
  overflow: hidden;
}
</style>
